<template>
  <abk-messages-list messages-status="sent" allow-copy/>
</template>

<script>
import AbkMessagesList from '../../../components/messages/AbkMessagesList'

export default {
  name: 'GroupMessagesTab',
  components: { AbkMessagesList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.messages.index_tabs.group_messages_tab.title')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped lang="scss">
</style>
